import { addPaymentInfo } from 'store/checkout/checkoutActions';
import { createAddPaymentInfoEvent } from '../eventCreators';
import { createAddPaymentInfoEventPayload } from '../dataHelpers/createAddPaymentInfoEventPayload';

const emitAddPaymentInfo = ({ payload }) => {
  const addPaymentInfoEvent = createAddPaymentInfoEvent(
    createAddPaymentInfoEventPayload({
      quote: payload.quote,
      payments: payload.payments,
      pointsConversion: payload.pointsConversion,
      isRebooked: payload.isRebooked,
    }),
  );

  return addPaymentInfoEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [addPaymentInfo]: emitAddPaymentInfo };
